import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

export type UseEmbedSignFormExperiment = ModelHookResult<{
	isEnabled: boolean;
	fullAddressCollectionIsEnabled: boolean;
}>;

export function useEmbedSignFormExperiment(): UseEmbedSignFormExperiment {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();

	const {
		data: {
			decisionMaker,
			signed,
			experiments: {
				supporterGrowthEmbedSignPetitionFormExperimentVariation,
				petitionSignFormFullAddressCollectionRolloutVariation,
			},
		},
	} = usePetitionDetailsPageUserData();

	/**
	 * Helps determine if the `onEnter` callback for the `InsideEmbeddedSignFormWaypoint` should be a no-op or not;
	 * if the full address collection experiment is enabled, the view event is being tracked in the `ContinueButton` component,
	 * so we do check this to avoid having a duplicate view event and pollute tracking data.
	 */
	const fullAddressCollectionIsEnabled = petitionSignFormFullAddressCollectionRolloutVariation === 'v1';

	/**
	 * Since other components already take care of displaying other petition states, we only
	 * want to worry about the unsigned state as part of the experiment.
	 */
	return {
		data: {
			isEnabled:
				!signed &&
				!decisionMaker &&
				status !== 'CLOSED' &&
				status !== 'VICTORY' &&
				supporterGrowthEmbedSignPetitionFormExperimentVariation === 'variant_1',
			fullAddressCollectionIsEnabled,
		},
	};
}
